import { createActions } from 'redux-actions';

export const {
  sendMessageFeedback,
  sendMessageFeedbackSuccess,
  sendMessageFeedbackError,
} = createActions(
  'SEND_MESSAGE_FEEDBACK',
  'SEND_MESSAGE_FEEDBACK_SUCCESS',
  'SEND_MESSAGE_FEEDBACK_ERROR'
);
